import { defaultAxios, IParams } from '../base';

export interface IFetchSelectTempPreRequest extends IParams {
  custSeq: string;
}

// 주담대 임시 신청 정보 확인
export const fetchSelectTempPreRequest = async (
  params: IFetchSelectTempPreRequest,
) => {
  return await defaultAxios().post(`/house/selectTempPreRequest`, params);
};
